import { render, staticRenderFns } from "./PurchaseOverview.vue?vue&type=template&id=3fff9bee"
import script from "./PurchaseOverview.vue?vue&type=script&lang=js"
export * from "./PurchaseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports